<template>
  <div class="contact-section" id="contact">
    <div class="container">
      <div class="row">
        <div class="col-12 contact-title">
          <h2>Kontaktirajte nas</h2>
        </div>
        <form class="contact-form col-12 row" @submit.prevent="save" id="contactForm">
          <div class="form-group col-6 form-l">
            <input v-model="name" type="text" class="form-control" name="name" placeholder="Ime">
            <input v-model="email" type="email" name="email" class="form-control" id="email" placeholder="Email"
                   v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('email')}">
            <p class="text-danger" v-if="errors.has('email')">{{ errors.first('email') }}</p>
            <input v-model="subject" type="text" name="subject" class="form-control" placeholder="Naslov">
          </div>
          <div class="form-group col-6 form-r">
              <textarea v-model="message" name="message" placeholder="Poruka" rows="10" v-validate="'required'"
                        :class="{'input': true, 'is-danger': errors.has('message') }"></textarea>
            <p class="text-danger" v-if="errors.has('message')">{{ errors.first('message') }}</p>
          </div>
          <div class="col-md-12 form-button-holder">
            <button type="submit" class="btn">Pošalji</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import VeeValidate from 'vee-validate';

  export default {
    data() {
      return {
        name: '',
        email: '',
        subject: '',
        message: ''
      }
    },
    methods: {
      save() {
        this.$validator.validateAll()
            .then((result) => {
              if (result) {
                this.loading = true

                axios.post('/static/phpForm/phpForm.php', {
                  name: this.name,
                  email: this.email,
                  subject: this.subject,
                  message: this.message
                })
                    .then((response) => {
                      this.name = '',
                          this.email = '',
                          this.subject = '',
                          this.message = '',
                          this.loading = false,
                          this.$nextTick(() => this.$validator.reset()),
                          this.$swal({
                            title: 'Poruka poslata!',
                            type: 'success',
                            showCloseButton: true,
                            showConfirmButton: true,
                            html: 'Vaša poruka je uspešno poslata.'
                          })
                    })
                    .catch((error) => {
                      this.loading = false
                    })
              }
            })
      }
    }
  }

</script>

<style>
  .text-danger {
    margin-bottom: 0 !important;
  }

  .swal2-popup {
    background: #f2f2f2 !important;
    border-radius: 0 !important;
  }

  .swal2-success-circular-line-left {
    background: #f2f2f2 !important;
  }

  .swal2-success-circular-line-right {
    background: #f2f2f2 !important;
  }

  .swal2-success-fix {
    background: #f2f2f2 !important;
  }

  .swal2-success-ring {
    border: .25em solid #0c4c6f !important;
  }

  .swal2-success-line-tip {
    background: #0c4c6f !important;
  }

  .swal2-success-line-long {
    background: #0c4c6f !important;
  }

  .swal2-title {
    color: #0c4c6f !important;
    font-weight: bold;
  }

  .swal2-content {
    color: #0c4c6f !important;
  }

  .swal2-confirm.swal2-styled {
    background: #0c4c6f !important;
    font-weight: bold !important;
    border-radius: 0 !important;
  }

  .swal2-confirm.swal2-styled:focus {
    box-shadow: none !important;
  }

  .swal2-close {
    color: #0c4c6f !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue